import React from 'react';
import { gql } from '@apollo/client';
import { FunctionField, Show, SimpleShowLayout, TextField } from 'react-admin';
import LinkField from 'components/LinkField';
import AgencyQualificationAttributeField from 'resources/professional_qualification_attributes/ProfessionalQualificationAttributeField';
import { JsonField } from 'react-admin-json-view';

const AgencyQualificationShow = () => (
  <Show>
    <SimpleShowLayout>
      <TextField source="id" />
      <LinkField label="Agency Qualification" source="agency_qualification.id" />
      <LinkField
        label="Agency"
        source="agency_qualification.agency_id"
        to={(record) => `/Agency/${record?.agency_qualification?.agency_id}/show`}
      />
      <FunctionField label="Type" render={(val) => val.type?.split('::')[1]} />
      <JsonField label="Metadata" source="metadata" />
      <AgencyQualificationAttributeField />
    </SimpleShowLayout>
  </Show>
);

AgencyQualificationShow.query = gql`
  query GET_ONE($id: Int!) {
    agencyQualificationAttribute(id: $id) {
      id
      agency_qualification {
        id
        agency_id
      }
      type
      value
      metadata
    }
  }
`;

export default AgencyQualificationShow;
